"use strict";

import { http } from '../../core';
import config from "../../app.config";
const RequestbaseURL = http.create({baseURL:config.BASEURL});
export default {
    getdictionary(){
        return RequestbaseURL.get("appcenter/apptree/v1/data/dictionary")
    },
    dictionaryList(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/data/dictionary/update', params)
    },
    dictionaryAdd(params) {
        return RequestbaseURL.post('appcenter/apptree/v1/data/dictionary/update', params)
    },
    dictionaryDel(params) {
        return RequestbaseURL.post('appcenter/apptree/v1/data/dictionary/update', params)
    },
    dictionaryEdit(params) {
        return RequestbaseURL.post('appcenter/apptree/v1/data/dictionary/update', params)
    },
}
